import { IMorningstarStyleBoxStyle } from '../models/index.js';
export const morningstarStyleBoxStyle: IMorningstarStyleBoxStyle = {
	// TODO: rawCssPrefix - create default styles here from SC rawCssPrefix
	children: {},
};
